"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _date = require("@ha/date");

var _constants = require("../constants");

var dateToTSBuilder = function dateToTSBuilder(_a, context) {
  var startDate = _a.startDate,
      endDate = _a.endDate,
      advertiserId = _a.advertiserId;

  if (!startDate && !endDate && advertiserId || (context === null || context === void 0 ? void 0 : context.withNewDateFilter)) {
    return '';
  }

  var isShortRange = Boolean(startDate && endDate && (0, _date.diffDay)(endDate, startDate) <= _constants.ShortRangeRentThreshold); // eslint-disable-next-line no-nested-ternary

  var end = endDate ? isShortRange ? endDate // do not add flexible dates if user is searching for a short period
  : (0, _date.addDays)(endDate, -_constants.DateFlexibility) : // If there is no end date specified, but there is a start date specified,
  // then the endDate should be greater than the startDate.
  startDate;
  var endDateTS = end ? (0, _date.dateToTimestamp)(new Date(end)) : '';
  var noEndDateTS = (0, _date.dateToTimestamp)(new Date(_date.NO_END));
  var multiuseEndDateTS = (0, _date.dateToTimestamp)(new Date(_constants.MULTIUSE_END));

  if (endDateTS) {
    return "(dateToTS>=" + endDateTS + " OR dateToTS=" + noEndDateTS + " OR dateToTS=" + multiuseEndDateTS + ")";
  }

  return '';
};

var _default = dateToTSBuilder;
exports["default"] = _default;